import React from 'react'
import { Link } from 'react-router-dom'
import logo from '../images/birdlogo.jpeg'
const Footer = () => {
    return (
        <div className='footer'>
            <img src={logo} alt='' className='footer-logo' />
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-lg-3'>
                    </div>
                    <div className='col-lg-6'>
                        <ul className='footer-menu'>
                            <li><Link to='/'> Home </Link></li>
                            <li><Link to='/about'>About Us</Link> </li>
                            <li><Link to='/contact'>Contact Us</Link> </li>
                        </ul>
                    </div>
                    <div className='col-lg-3'>
                        <div className='phone-nmber'>
                            <header>Mobile numbers </header>

                            <header >  Sohail Ahmad:+971569003156 </header>
                            <article>Fawad khan +971563099584 &</article>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Footer